module.exports = __webpack_public_path__ + "61d387edd9eb40ae2fd9d8025618ccdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-5.png
// module id = 309
// module chunks = 1